// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyALWLHqmvQySLxpSleT7WfjNpXhvAatv3M",
  authDomain: "mdtajuudintarek.firebaseapp.com",
  projectId: "mdtajuudintarek",
  storageBucket: "mdtajuudintarek.appspot.com",
  messagingSenderId: "84148796106",
  appId: "1:84148796106:web:4fa0a6ea601e705960d233",
  measurementId: "G-94DF437MRE"
};

export default firebaseConfig;